module.exports = __webpack_public_path__ + "bf9f44299c65b3d6166baa0f6e182238.png";